import { render, staticRenderFns } from "./pie.vue?vue&type=template&id=37eb13cc&scoped=true&"
import script from "./pie.vue?vue&type=script&lang=js&"
export * from "./pie.vue?vue&type=script&lang=js&"
import style0 from "./pie.vue?vue&type=style&index=0&id=37eb13cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37eb13cc",
  null
  
)

export default component.exports